import { render } from "./LoadingScreenSection.vue?vue&type=template&id=6ca9735a&scoped=true"
import script from "./LoadingScreenSection.vue?vue&type=script&lang=js"
export * from "./LoadingScreenSection.vue?vue&type=script&lang=js"

import "./LoadingScreenSection.vue?vue&type=style&index=0&id=6ca9735a&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\registration2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca9735a"]])

export default __exports__